import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, ToastController, ActionSheetController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { AppSettings } from '../services/app-settings';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TabsPage } from '../pages/tabs/tabs';


@Component({
  templateUrl: 'app.html'
})



export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{ title: string, component: any, icon: string }>;
  previousConnectionStatus: any = 'ONLINE';
  firebasePlugin;
  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen,
    private appVersion: AppVersion,
    private alertCtrl: AlertController,
    private network: Network,
    private toastCtrl: ToastController,
    private iab: InAppBrowser,
    public actionSheetCtrl: ActionSheetController,
  ) {
    this.initializeApp();

    this.pages = [
      { title: 'ראשי', component: 'HomePage', icon: 'home-outline' },
      { title: 'זימון חדר', component: 'ManageEventDetailsPage', icon: 'calendar-outline' },
      { title: 'עזרה', component: 'HelpPage', icon: 'information-circle-outline' },
      { title: 'חייג לתמיכה', component: 'PhoneSupport', icon: 'phone-portrait-outline' },
      { title: 'שיתוף', component: 'SharePage', icon: 'share-outline' },
      { title: 'התנתקות', component: 'LogOut', icon: 'exit-outline' },
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.checkVersion();
      this.initializeNetworkEvents();


      let userid = localStorage.getItem('user_id');
      if (userid && userid != "undefined") {
        this.nav.setRoot(HomePage);
      } else {
        this.nav.setRoot('LoginPage');
      }



      // this.firebasePlugin = (<any>window).FirebasePlugin;

      // if (this.platform.is('cordova')) {
      //   if (this.platform.is('android')) {
      //     this.initializeFireBaseAndroid();
      //   }
      //   if (this.platform.is('ios')) {
      //     this.initializeFireBaseIos();
      //   }
      // }

      this.platform.registerBackButtonAction(() => {
        if (this.nav.length() == 1) {
          let alert = this.alertCtrl.create({
            title: 'אישור יציאה מהאפליקציה',
            //message: 'Do you want to exit?',
            buttons: [
              {
                text: "יציאה", handler: () => {
                  this.platform.exitApp();
                }
              },
              { text: "ביטול", role: 'cancel' }
            ]
          });
          alert.present();
        } else
          this.nav.pop();
      });





    });
  }

  whatsNew(text) {
    if (typeof text == "object" && text.length > 0) {
      let textparse = '';
      text.forEach(element => {
        textparse += '<li>' + element + '</li>';
      });

      let alertBox = this.alertCtrl.create({
        title: 'מה חדש בגרסה זו',
        message: `<ul>` + textparse + ` </ul>`,
        buttons: ['אישור']
      });
      alertBox.present();
    }
    else {
      let alertBox = this.alertCtrl.create({
        title: 'לא הוגדרו עידכונים לגרסה זו',
        buttons: ['אישור']
      });
      alertBox.present();
    }
  }

  async checkVersion() {

    await this.appVersion.getVersionNumber().then((version) => {
      let appPlatform = this.platform.is('android') ? 'android' : 'ios';
      fetch(AppSettings.APP_VERSION + '?platform=' + appPlatform)
        .then(response => response.json())
        .then(data => {
          let remote_version = data['app_version'];
          let whatsnew = data['whatsnew'];
          // let version: any = '2.2';
          if (remote_version > version) {
            let alertBox = this.alertCtrl.create({
              title: '<b>עידכון קיים</b>',
              subTitle: 'עידכון גרסה: ' + remote_version + ' זמין להורדה',
              buttons: [

                {
                  text: 'הורדה',
                  handler: () => {
                    let downloadlink = '';
                    if (this.platform.is('android')) {
                      downloadlink = 'https://play.google.com/store/apps/details?id=com.atarix.roo';
                    } else {
                      downloadlink = 'https://apps.apple.com/app/roo/id6503189708';
                    }
                    if (downloadlink) {
                      const browser = this.iab.create(downloadlink, '_system');
                      // window.open(downloadlink, '_blank', 'location=yes');
                    }
                  }
                },
                {
                  text: 'מה חדש בגרסה זו',
                  handler: () => {
                    this.whatsNew(whatsnew);
                  }
                },
                {
                  text: 'ביטול',
                  role: 'cancel',
                  handler: () => {
                    console.log('Cancel clicked');
                  }
                },
              ]
            });
            alertBox.present();
          }
        })
        .catch((apiError => {
        }));

    }, (versionError) => {
      console.log(versionError);
    });
  }



  private initializeFireBaseAndroid(): Promise<any> {

    return this.firebasePlugin.getToken(token => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }

  private initializeFireBaseIos(): Promise<any> {

    return this.firebasePlugin.grantPermission(data => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }



  subscribeToPushNotificationEvents() {
    // Handle token refresh

    this.firebasePlugin.onTokenRefresh((token) => {
      this.sendPushtoserver(token);
    });


    this.firebasePlugin.onMessageReceived((notification) => {
      if (!notification.tap) {
        //alert(JSON.stringify(notification));
      }
      else {

      }
    })
  }


  async sendPushtoserver(token) {
    if (token) {
      localStorage.setItem("push", token);
    }
  }



  public initializeNetworkEvents(): void {
    this.network.onDisconnect().subscribe(() => {
      if (this.previousConnectionStatus == "ONLINE") {
        this.presentToast("מנותק מהאינטרנט");
      }
      this.previousConnectionStatus = "OFFLINE";
    });
    this.network.onConnect().subscribe(() => {
      if (this.previousConnectionStatus == "OFFLINE") {
        this.presentToast("מחובר לאינטרנט");
      }
      this.previousConnectionStatus = "ONLINE";
    });

    this.network.onchange().subscribe(() => {

      setTimeout(() => {
        if (this.network.type === '2g' || this.network.type === '3g' || this.network.type === 'unknown') {
          this.presentToast("חיבור אינטרנט איטי מהרגיל");
        }
      }, 3000);

    });
  }

  openPage(page) {
    console.log("page", page);
    if (page.title == "התנתקות") {

      let alertBox = this.alertCtrl.create({
        title: '<b>האם לאשר התנתקות מהמערכת?</b>',
        subTitle: '',
        buttons: [
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'יציאה',
            handler: () => {
              localStorage.removeItem("user_id");
              localStorage.removeItem("token");
              this.nav.setRoot('LoginPage');
            }
          }
        ]
      });
      alertBox.present();
    }
    else if (page.title == "ראשי") {
      this.nav.setRoot(HomePage);
    }
    else if (page.title == "חייג לתמיכה") {
      const browser = this.iab.create("tel:048727969", '_system');
    }
    else if (page.title == "שיתוף") {

      let actionSheet = this.actionSheetCtrl.create({
        title: 'שיתוף האפליקציה',
        buttons: [

          {
            text: 'אימייל',
            icon: 'mail-outline',
            handler: () => {
              const browser = this.iab.create("mailto:?subject=אפליקציית Roo&body=מערכת ניהול חדרים\n להורדה אנדרואיד: https://bit.ly/3XL14fS \n להורדה אייפון: https://apple.co/4eItpt6", '_system');
            }
          },
          {
            text: 'SMS',
            icon: 'text-outline',
            handler: () => {
              console.log('Archive clicked');
              const browser = this.iab.create("sms:?&body=מערכת ניהול חדרים\n להורדה אנדרואיד: https://bit.ly/3XL14fS \n להורדה אייפון: https://apple.co/4eItpt6", '_system');
            }
          },
          {
            text: 'WhatsApp',
            icon: 'logo-whatsapp',
            handler: () => {
              console.log('Archive clicked');
              const browser = this.iab.create("https://api.whatsapp.com/send?text=מערכת ניהול חדרים\n להורדה אנדרואיד: https://bit.ly/3XL14fS \n להורדה אייפון: https://apple.co/4eItpt6", '_blank');
            }
          },
          {
            text: 'ביטול',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });

      actionSheet.present();


    } else if (page.title == "כתוב ביקורת") {
      let downloadlink = '';
      if (this.platform.is('android')) {
        downloadlink = 'https://play.google.com/store/apps/details?id=com.atarix.roo';
      } else {
        downloadlink = 'https://apps.apple.com/app/roo/id6503189708?mt=8&action=write-review';
      }
      const browser = this.iab.create(downloadlink, '_system');
    }
    else {
      this.nav.push(page.component);
    }
  }

  presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts